export const RESPONSE_PENDING = -100
export const RESPONSE_OFFLINE = null
export const RESPONSE_BADRESPONSE = -400
export const RESPONSE_BADDATA = -406
export const RESPONSE_NOTFOUND = -404
export const RESPONSE_UNAUTHORIZED = -401
export const RESPONSE_FORBIDDEN = -403

export default {
  RESPONSE_PENDING,
  RESPONSE_OFFLINE,
  RESPONSE_BADRESPONSE,
  RESPONSE_BADDATA,
  RESPONSE_NOTFOUND,
  RESPONSE_UNAUTHORIZED,
  RESPONSE_FORBIDDEN
}
